import React from "react";
import Spinner from "../../../../../Components/Common/Spinner";

const TableTdPrice = ({priceKey, width, colSpan, productPriceList, loadingPriceList}) => {
    let priceItem;
    if(!priceKey || !productPriceList) {
        priceItem = 'Op aanvraag';
    } else {
        // priceKey = `${productCode}-${unitCode}` — @see PriceListService::priceKey
        const price = productPriceList[priceKey];
        priceItem = (price?.price);
    }

    return (
        <td
            scope="col"
            width={width}
            colSpan={colSpan}
            style={{whiteSpace: 'nowrap'}}
        >
            <React.Suspense fallback={<Spinner/>}>
                {loadingPriceList ? <Spinner/> : priceItem}
            </React.Suspense>
        </td>
    )
}

export default TableTdPrice;
